/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { SiteTypeDeviceActivityPlan } from '../models/site-type-device-activity-plan';
import { DeviceActivityType } from '../models/device-activity-type';
import { SiteTypeWithActivityPlan } from '../models/site-type-with-activity-plan';
import { DeviceActivityRecord } from '../models/device-activity-record';
import { DeviceActivityUpload } from '../models/device-activity-upload';
@Injectable({
  providedIn: 'root',
})
class SiteTypeDeviceActivityPlanService extends __BaseService {
  static readonly SiteTypeDeviceActivityPlanInsertPath = '/api/SiteTypeDeviceActivityPlan/Insert';
  static readonly SiteTypeDeviceActivityPlanUpdatePath = '/api/SiteTypeDeviceActivityPlan/Update';
  static readonly SiteTypeDeviceActivityPlanDeletePath = '/api/SiteTypeDeviceActivityPlan/Delete';
  static readonly SiteTypeDeviceActivityPlanGetPath = '/api/SiteTypeDeviceActivityPlan/Get';
  static readonly SiteTypeDeviceActivityPlanGetAllForSiteTypePath = '/api/SiteTypeDeviceActivityPlan/GetAllForSiteType';
  static readonly SiteTypeDeviceActivityPlanGetAllActivityTypesPath = '/api/SiteTypeDeviceActivityPlan/GetAllActivityTypes';
  static readonly SiteTypeDeviceActivityPlanGetAllSiteTypesWithActivityTypesPath = '/api/SiteTypeDeviceActivityPlan/GetAllSiteTypesWithActivityTypes';
  static readonly SiteTypeDeviceActivityPlanGetDeviceActivitiesPath = '/api/SiteTypeDeviceActivityPlan/GetDeviceActivities/{customerId}';
  static readonly SiteTypeDeviceActivityPlanDeleteDeviceActivityPath = '/api/SiteTypeDeviceActivityPlan/DeleteDeviceActivity/{customerId}/{deviceActivityId}';
  static readonly SiteTypeDeviceActivityPlanReprocessDeviceActivityPath = '/api/SiteTypeDeviceActivityPlan/ReprocessDeviceActivity/{customerId}/{deviceActivityId}';
  static readonly SiteTypeDeviceActivityPlanUpdateDeviceActivityPath = '/api/SiteTypeDeviceActivityPlan/UpdateDeviceActivity/{customerId}/{deviceActivityId}';
  static readonly SiteTypeDeviceActivityPlanUploadActivityPlansPath = '/api/SiteTypeDeviceActivityPlan/UploadCompletedPlan';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `SiteTypeDeviceActivityPlanService.SiteTypeDeviceActivityPlanInsertParams` containing the following parameters:
   *
   * - `newplan`:
   *
   * - `siteTypeId`:
   *
   * - `customerId`:
   */
  SiteTypeDeviceActivityPlanInsertResponse(params: SiteTypeDeviceActivityPlanService.SiteTypeDeviceActivityPlanInsertParams): __Observable<__StrictHttpResponse<SiteTypeDeviceActivityPlan>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.newplan;
    if (params.siteTypeId != null) __params = __params.set('siteTypeId', params.siteTypeId.toString());
    if (params.customerId != null) __params = __params.set('customerId', params.customerId.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/SiteTypeDeviceActivityPlan/Insert`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SiteTypeDeviceActivityPlan>;
      })
    );
  }
  /**
   * @param params The `SiteTypeDeviceActivityPlanService.SiteTypeDeviceActivityPlanInsertParams` containing the following parameters:
   *
   * - `newplan`:
   *
   * - `siteTypeId`:
   *
   * - `customerId`:
   */
  SiteTypeDeviceActivityPlanInsert(params: SiteTypeDeviceActivityPlanService.SiteTypeDeviceActivityPlanInsertParams): __Observable<SiteTypeDeviceActivityPlan> {
    return this.SiteTypeDeviceActivityPlanInsertResponse(params).pipe(
      __map(_r => _r.body as SiteTypeDeviceActivityPlan)
    );
  }

  /**
   * @param params The `SiteTypeDeviceActivityPlanService.SiteTypeDeviceActivityPlanUpdateParams` containing the following parameters:
   *
   * - `updatePlan`:
   *
   * - `customerId`:
   */
  SiteTypeDeviceActivityPlanUpdateResponse(params: SiteTypeDeviceActivityPlanService.SiteTypeDeviceActivityPlanUpdateParams): __Observable<__StrictHttpResponse<SiteTypeDeviceActivityPlan>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.updatePlan;
    if (params.customerId != null) __params = __params.set('customerId', params.customerId.toString());
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/SiteTypeDeviceActivityPlan/Update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SiteTypeDeviceActivityPlan>;
      })
    );
  }
  /**
   * @param params The `SiteTypeDeviceActivityPlanService.SiteTypeDeviceActivityPlanUpdateParams` containing the following parameters:
   *
   * - `updatePlan`:
   *
   * - `customerId`:
   */
  SiteTypeDeviceActivityPlanUpdate(params: SiteTypeDeviceActivityPlanService.SiteTypeDeviceActivityPlanUpdateParams): __Observable<SiteTypeDeviceActivityPlan> {
    return this.SiteTypeDeviceActivityPlanUpdateResponse(params).pipe(
      __map(_r => _r.body as SiteTypeDeviceActivityPlan)
    );
  }

  /**
   * @param params The `SiteTypeDeviceActivityPlanService.SiteTypeDeviceActivityPlanDeleteParams` containing the following parameters:
   *
   * - `planId`:
   *
   * - `customerId`:
   */
  SiteTypeDeviceActivityPlanDeleteResponse(params: SiteTypeDeviceActivityPlanService.SiteTypeDeviceActivityPlanDeleteParams): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.planId != null) __params = __params.set('planId', params.planId.toString());
    if (params.customerId != null) __params = __params.set('customerId', params.customerId.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/SiteTypeDeviceActivityPlan/Delete`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `SiteTypeDeviceActivityPlanService.SiteTypeDeviceActivityPlanDeleteParams` containing the following parameters:
   *
   * - `planId`:
   *
   * - `customerId`:
   */
  SiteTypeDeviceActivityPlanDelete(params: SiteTypeDeviceActivityPlanService.SiteTypeDeviceActivityPlanDeleteParams): __Observable<Blob> {
    return this.SiteTypeDeviceActivityPlanDeleteResponse(params).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param params The `SiteTypeDeviceActivityPlanService.SiteTypeDeviceActivityPlanGetParams` containing the following parameters:
   *
   * - `siteTypeId`:
   *
   * - `customerId`:
   */
  SiteTypeDeviceActivityPlanGetResponse(params: SiteTypeDeviceActivityPlanService.SiteTypeDeviceActivityPlanGetParams): __Observable<__StrictHttpResponse<SiteTypeDeviceActivityPlan>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.siteTypeId != null) __params = __params.set('siteTypeId', params.siteTypeId.toString());
    if (params.customerId != null) __params = __params.set('customerId', params.customerId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/SiteTypeDeviceActivityPlan/Get`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SiteTypeDeviceActivityPlan>;
      })
    );
  }
  /**
   * @param params The `SiteTypeDeviceActivityPlanService.SiteTypeDeviceActivityPlanGetParams` containing the following parameters:
   *
   * - `siteTypeId`:
   *
   * - `customerId`:
   */
  SiteTypeDeviceActivityPlanGet(params: SiteTypeDeviceActivityPlanService.SiteTypeDeviceActivityPlanGetParams): __Observable<SiteTypeDeviceActivityPlan> {
    return this.SiteTypeDeviceActivityPlanGetResponse(params).pipe(
      __map(_r => _r.body as SiteTypeDeviceActivityPlan)
    );
  }

  /**
   * @param params The `SiteTypeDeviceActivityPlanService.SiteTypeDeviceActivityPlanGetAllForSiteTypeParams` containing the following parameters:
   *
   * - `siteTypeId`:
   *
   * - `customerId`:
   */
  SiteTypeDeviceActivityPlanGetAllForSiteTypeResponse(params: SiteTypeDeviceActivityPlanService.SiteTypeDeviceActivityPlanGetAllForSiteTypeParams): __Observable<__StrictHttpResponse<Array<SiteTypeDeviceActivityPlan>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.siteTypeId != null) __params = __params.set('siteTypeId', params.siteTypeId.toString());
    if (params.customerId != null) __params = __params.set('customerId', params.customerId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/SiteTypeDeviceActivityPlan/GetAllForSiteType`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<SiteTypeDeviceActivityPlan>>;
      })
    );
  }
  /**
   * @param params The `SiteTypeDeviceActivityPlanService.SiteTypeDeviceActivityPlanGetAllForSiteTypeParams` containing the following parameters:
   *
   * - `siteTypeId`:
   *
   * - `customerId`:
   */
  SiteTypeDeviceActivityPlanGetAllForSiteType(params: SiteTypeDeviceActivityPlanService.SiteTypeDeviceActivityPlanGetAllForSiteTypeParams): __Observable<Array<SiteTypeDeviceActivityPlan>> {
    return this.SiteTypeDeviceActivityPlanGetAllForSiteTypeResponse(params).pipe(
      __map(_r => _r.body as Array<SiteTypeDeviceActivityPlan>)
    );
  }

  /**
   * @param customerId undefined
   */
  SiteTypeDeviceActivityPlanGetAllActivityTypesResponse(customerId?: number): __Observable<__StrictHttpResponse<Array<DeviceActivityType>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (customerId != null) __params = __params.set('customerId', customerId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/SiteTypeDeviceActivityPlan/GetAllActivityTypes`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<DeviceActivityType>>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  SiteTypeDeviceActivityPlanGetAllActivityTypes(customerId?: number): __Observable<Array<DeviceActivityType>> {
    return this.SiteTypeDeviceActivityPlanGetAllActivityTypesResponse(customerId).pipe(
      __map(_r => _r.body as Array<DeviceActivityType>)
    );
  }

  /**
   * @param customerId undefined
   */
  SiteTypeDeviceActivityPlanGetAllSiteTypesWithActivityTypesResponse(customerId?: number): __Observable<__StrictHttpResponse<Array<SiteTypeWithActivityPlan>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (customerId != null) __params = __params.set('customerId', customerId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/SiteTypeDeviceActivityPlan/GetAllSiteTypesWithActivityTypes`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<SiteTypeWithActivityPlan>>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  SiteTypeDeviceActivityPlanGetAllSiteTypesWithActivityTypes(customerId?: number): __Observable<Array<SiteTypeWithActivityPlan>> {
    return this.SiteTypeDeviceActivityPlanGetAllSiteTypesWithActivityTypesResponse(customerId).pipe(
      __map(_r => _r.body as Array<SiteTypeWithActivityPlan>)
    );
  }

  /**
   * @param customerId undefined
   */
  SiteTypeDeviceActivityPlanGetDeviceActivitiesResponse(customerId: number): __Observable<__StrictHttpResponse<Array<DeviceActivityRecord>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/SiteTypeDeviceActivityPlan/GetDeviceActivities/${encodeURIComponent(String(customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<DeviceActivityRecord>>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  SiteTypeDeviceActivityPlanGetDeviceActivities(customerId: number): __Observable<Array<DeviceActivityRecord>> {
    return this.SiteTypeDeviceActivityPlanGetDeviceActivitiesResponse(customerId).pipe(
      __map(_r => _r.body as Array<DeviceActivityRecord>)
    );
  }

  /**
   * @param params The `SiteTypeDeviceActivityPlanService.SiteTypeDeviceActivityPlanDeleteDeviceActivityParams` containing the following parameters:
   *
   * - `deviceActivityId`:
   *
   * - `customerId`:
   */
  SiteTypeDeviceActivityPlanDeleteDeviceActivityResponse(params: SiteTypeDeviceActivityPlanService.SiteTypeDeviceActivityPlanDeleteDeviceActivityParams): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/SiteTypeDeviceActivityPlan/DeleteDeviceActivity/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.deviceActivityId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `SiteTypeDeviceActivityPlanService.SiteTypeDeviceActivityPlanDeleteDeviceActivityParams` containing the following parameters:
   *
   * - `deviceActivityId`:
   *
   * - `customerId`:
   */
  SiteTypeDeviceActivityPlanDeleteDeviceActivity(params: SiteTypeDeviceActivityPlanService.SiteTypeDeviceActivityPlanDeleteDeviceActivityParams): __Observable<Blob> {
    return this.SiteTypeDeviceActivityPlanDeleteDeviceActivityResponse(params).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param params The `SiteTypeDeviceActivityPlanService.SiteTypeDeviceActivityPlanReprocessDeviceActivityParams` containing the following parameters:
   *
   * - `deviceActivityId`:
   *
   * - `customerId`:
   */
  SiteTypeDeviceActivityPlanReprocessDeviceActivityResponse(params: SiteTypeDeviceActivityPlanService.SiteTypeDeviceActivityPlanReprocessDeviceActivityParams): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/SiteTypeDeviceActivityPlan/ReprocessDeviceActivity/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.deviceActivityId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `SiteTypeDeviceActivityPlanService.SiteTypeDeviceActivityPlanReprocessDeviceActivityParams` containing the following parameters:
   *
   * - `deviceActivityId`:
   *
   * - `customerId`:
   */
  SiteTypeDeviceActivityPlanReprocessDeviceActivity(params: SiteTypeDeviceActivityPlanService.SiteTypeDeviceActivityPlanReprocessDeviceActivityParams): __Observable<Blob> {
    return this.SiteTypeDeviceActivityPlanReprocessDeviceActivityResponse(params).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param params The `SiteTypeDeviceActivityPlanService.SiteTypeDeviceActivityPlanUpdateDeviceActivityParams` containing the following parameters:
   *
   * - `deviceActivityId`:
   *
   * - `deviceActivity`:
   *
   * - `customerId`:
   */
  SiteTypeDeviceActivityPlanUpdateDeviceActivityResponse(params: SiteTypeDeviceActivityPlanService.SiteTypeDeviceActivityPlanUpdateDeviceActivityParams): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.deviceActivity;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/SiteTypeDeviceActivityPlan/UpdateDeviceActivity/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.deviceActivityId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `SiteTypeDeviceActivityPlanService.SiteTypeDeviceActivityPlanUpdateDeviceActivityParams` containing the following parameters:
   *
   * - `deviceActivityId`:
   *
   * - `deviceActivity`:
   *
   * - `customerId`:
   */
  SiteTypeDeviceActivityPlanUpdateDeviceActivity(params: SiteTypeDeviceActivityPlanService.SiteTypeDeviceActivityPlanUpdateDeviceActivityParams): __Observable<Blob> {
    return this.SiteTypeDeviceActivityPlanUpdateDeviceActivityResponse(params).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param plan undefined
   */
  SiteTypeDeviceActivityPlanUploadActivityPlansResponse(plan: DeviceActivityUpload): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = plan;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/SiteTypeDeviceActivityPlan/UploadCompletedPlan`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param plan undefined
   */
  SiteTypeDeviceActivityPlanUploadActivityPlans(plan: DeviceActivityUpload): __Observable<Blob> {
    return this.SiteTypeDeviceActivityPlanUploadActivityPlansResponse(plan).pipe(
      __map(_r => _r.body as Blob)
    );
  }
}

module SiteTypeDeviceActivityPlanService {

  /**
   * Parameters for SiteTypeDeviceActivityPlanInsert
   */
  export interface SiteTypeDeviceActivityPlanInsertParams {
    newplan: SiteTypeDeviceActivityPlan;
    siteTypeId?: number;
    customerId?: number;
  }

  /**
   * Parameters for SiteTypeDeviceActivityPlanUpdate
   */
  export interface SiteTypeDeviceActivityPlanUpdateParams {
    updatePlan: SiteTypeDeviceActivityPlan;
    customerId?: number;
  }

  /**
   * Parameters for SiteTypeDeviceActivityPlanDelete
   */
  export interface SiteTypeDeviceActivityPlanDeleteParams {
    planId?: number;
    customerId?: number;
  }

  /**
   * Parameters for SiteTypeDeviceActivityPlanGet
   */
  export interface SiteTypeDeviceActivityPlanGetParams {
    siteTypeId?: number;
    customerId?: number;
  }

  /**
   * Parameters for SiteTypeDeviceActivityPlanGetAllForSiteType
   */
  export interface SiteTypeDeviceActivityPlanGetAllForSiteTypeParams {
    siteTypeId?: number;
    customerId?: number;
  }

  /**
   * Parameters for SiteTypeDeviceActivityPlanDeleteDeviceActivity
   */
  export interface SiteTypeDeviceActivityPlanDeleteDeviceActivityParams {
    deviceActivityId: number;
    customerId: number;
  }

  /**
   * Parameters for SiteTypeDeviceActivityPlanReprocessDeviceActivity
   */
  export interface SiteTypeDeviceActivityPlanReprocessDeviceActivityParams {
    deviceActivityId: number;
    customerId: number;
  }

  /**
   * Parameters for SiteTypeDeviceActivityPlanUpdateDeviceActivity
   */
  export interface SiteTypeDeviceActivityPlanUpdateDeviceActivityParams {
    deviceActivityId: number;
    deviceActivity: DeviceActivityRecord;
    customerId: number;
  }
}

export { SiteTypeDeviceActivityPlanService }
